export enum BusinessDocumentType {
  ein = 'ein',
  duns = 'duns',
  businessRegistration = 'business_registration',
  businessLicense = 'business_license',
  stateRegistration = 'state_registration',
  salesTaxPermit = 'sales_tax_permit',
  operatingLicense = 'operating_license',
  insurancePolicy = 'insurance_policy',
  bankAccount = 'bank_account',
  certificateOfGoodStanding = 'certificate_of_good_standing',
  articlesOfIncorporation = 'articles_of_incorporation',
  bylaws = 'bylaws',
  operatingAgreement = 'operating_agreement',
  other = 'other',
}

export const BusinessDocumentTypeLabels: Record<BusinessDocumentType, string> = {
  [BusinessDocumentType.ein]: 'EIN (Employer Identification Number)',
  [BusinessDocumentType.duns]: 'DUNS Number',
  [BusinessDocumentType.businessRegistration]: 'Business Registration',
  [BusinessDocumentType.businessLicense]: 'Business License',
  [BusinessDocumentType.stateRegistration]: 'State Registration',
  [BusinessDocumentType.salesTaxPermit]: 'Sales Tax Permit',
  [BusinessDocumentType.operatingLicense]: 'Operating License',
  [BusinessDocumentType.insurancePolicy]: 'Insurance Policy',
  [BusinessDocumentType.bankAccount]: 'Bank Account Documentation',
  [BusinessDocumentType.certificateOfGoodStanding]: 'Certificate of Good Standing',
  [BusinessDocumentType.articlesOfIncorporation]: 'Articles of Incorporation',
  [BusinessDocumentType.bylaws]: 'Bylaws',
  [BusinessDocumentType.operatingAgreement]: 'Operating Agreement',
  [BusinessDocumentType.other]: 'Other',
};

export enum BusinessDocumentStatus {
  active = 'active',
  expired = 'expired',
  pendingRenewal = 'pending_renewal',
  archived = 'archived',
}

export const BusinessDocumentStatusLabels: Record<BusinessDocumentStatus, string> = {
  [BusinessDocumentStatus.active]: 'Active',
  [BusinessDocumentStatus.expired]: 'Expired',
  [BusinessDocumentStatus.pendingRenewal]: 'Pending Renewal',
  [BusinessDocumentStatus.archived]: 'Archived',
};

export interface BusinessDocument {
  id: string;
  name: string;
  type: BusinessDocumentType;
  documentNumber?: string; // EIN, DUNS, license number, etc.
  status: BusinessDocumentStatus;
  
  // File information
  fileUrl?: string;
  fileName?: string;
  fileSize?: number; // in bytes
  mimeType?: string;
  
  // Dates
  issueDate?: Date;
  expirationDate?: Date;
  renewalDate?: Date;
  
  // Additional information
  description?: string;
  issuingAuthority?: string; // IRS, State, etc.
  notes?: string;
  
  // Metadata
  tags: string[];
  metadata?: Record<string, unknown>;
  
  // Ownership
  createdBy: string;
  createdByName: string;
  createdAt: Date;
  updatedAt: Date;
  lastReviewedAt?: Date;
  lastReviewedBy?: string;
}
